import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Modal } from "@lib/modal";
import { useRootAppStore } from "@hooks";
import { useGamesNavigation } from "@state/hooks/games/useGamesNavigation";
import HeaderResponsibleGamingConfirmation from "./HeaderResponsibleGamingConfirmation";

export function HeaderGamesNavItem() {
	const [
		isResponsibleGamingConfirmationPopupOpened,
		setIsResponsibleGamingConfirmationPopupOpened,
	] = useState(false);

	return (
		<>
			<HeaderGamesNavLi
				setFlag={setIsResponsibleGamingConfirmationPopupOpened}
			/>

			<Modal>
				{isResponsibleGamingConfirmationPopupOpened && (
					<HeaderResponsibleGamingConfirmation
						setFlag={setIsResponsibleGamingConfirmationPopupOpened}
					/>
				)}
			</Modal>
		</>
	);
}

const HeaderGamesNavLi = observer(function HeaderGamesNavLi(props: {
	setFlag: (value: boolean) => void;
}) {
	const { t } = useTranslation();
	const { userAuthStore } = useRootAppStore();
	const { handleGamesRedirection } = useGamesNavigation();

	const handleCasinoClick = () => {
		if (
			userAuthStore.isLoggedIn &&
			userAuthStore.user &&
			userAuthStore.isInternetUser
		) {
			props.setFlag(true);
		} else {
			handleGamesRedirection();
		}
	};

	return (
		<li className="nav--primary__item">
			<div className="nav--primary__link" onClick={handleCasinoClick}>
				{t("specific:HEADER.CASINO")}
			</div>
		</li>
	);
});
